import selectCompanyModalTemplate from '../views/modals/selected-company-modal.tpl.html';

class AuthController {
    constructor($auth, locale, $rootScope, $state, Alert, $uibModal, $scope, $http, Users, SweetAlert, $translate) {
        this.auth = $auth;
        this.locale = locale;
        this.rootScope = $rootScope;
        this.state = $state;
        this.alert = Alert;
        this.sweetAlert = SweetAlert;
        this.modal = $uibModal;
        this.scope = $scope;
        this.api = $http;
        this.userStore = Users;
        this.translate = $translate;

        this.companyUid = null;
    }

    login(credentials) {
        credentials = _.clone(credentials);
        const translatedValue = (path) => {
            return this.translate.instant(`auth.error_login_failed.${path}`);
        };

        this.api.post('auth/login', {
            ...credentials,
            company_uid: this.companyUid
        }).then((response) => {
            this.rootScope.user = _.get(response, 'data.data.user');
            this.auth.setToken(_.get(response, 'data.data.token'));
            location.reload();
        }, (errorResponse) => {
            if (errorResponse && errorResponse.status === 400 && _.get(errorResponse, 'data.data.error') === 'invalid_company_provided') {
                const availableCompanies = _.get(errorResponse, 'data.data.available_companies');

                this.modal.open({
                    controller: 'SelectCompanyModalController',
                    controllerAs: 'vm',
                    size: 'sm',
                    templateUrl: selectCompanyModalTemplate,
                    resolve: {
                        availableCompanies: () => {
                            return availableCompanies;
                        }
                    }
                }).result.then((dataFromModal) => {
                    this.companyUid = dataFromModal.selectedCompany.uid;
                    this.login(credentials);
                    this.scope.$applyAsync();
                }, () => {
                    this.state.go('auth.login', {}, {reload: true});
                }).catch((e) => {
                    this.alert.handle(e);
                });
            } else {
                this.alert.animatedAlert(
                    translatedValue('title'),
                    errorResponse.data.message,
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            }
        });
    }

    forgot(email) {
        this.auth.recoverPassword(email).then((response) => {
            this.sweetAlert.success(this.locale.getString('auth.recover_successful'), this.locale.getString('auth.recover_successful_message'));
            this.state.go('auth.login');
        }, (response) => {
            this.alert.handle(response);
        });
    }
}

AuthController.$inject = [
    '$auth',
    'locale',
    '$rootScope',
    '$state',
    'Alert',
    '$uibModal',
    '$scope',
    '$http',
    'Users',
    'SweetAlert',
    '$translate'
];

/**
 * @ngdoc object
 * @name auth.controller:AuthCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.auth')
    .controller('AuthCtrl', AuthController);



// WEBPACK FOOTER //
// ./src/app/pages/auth/controllers/auth-controller.js